/* ==========================================================================
   スライドショーの切り替えをフェード＋ゆっくり拡大にする（ルミエール独自 / 2026-10-04 claude）
   対象：sections/slideshow.liquid（トップページのメインスライダー）

   【元の動き】
     テーマ（Dawn）のスライドショーは、横に並べたスライドをスクロールさせて切り替える。
     パソコンの「アニメーションを減らす」設定がONだとスクロールが一瞬で終わり、
     画像がパッと切り替わって見えた。

   【この部品がすること】
     テーマが切り替えのためにスクロールする直前に、いま見えているスライドの複製を
     上に重ね、スクロール（瞬時）の後でその複製をゆっくり透明にして消す。
     → 古い画像から新しい画像へのクロスフェードになる。
     さらに、表示中の画像を少しずつ拡大する（参考：https://www.zushiya.com/ のトップ）。
     消えていく画像は拡大したその大きさのまま薄れ、次の画像は元の大きさから拡大を始める。

   ・自動再生・矢印・ドットはテーマの仕組みのまま（スクロール命令を横取りするだけ）
   ・スマホの指でのスワイプは、これまでどおり横に滑る（スクロール命令を使わないため）
   ・フェードの長さは FADE_MS、拡大の倍率は ZOOM_SCALE で変更できる
   ・拡大にかける時間は、自動再生の間隔（セクション設定「スライドの変更間隔」）に
     合わせて自動で決まる（次へ切り替わるまでずっと少しずつ大きくなる）
   ・やめたいときは sections/slideshow.liquid の読み込み1行を消すだけ

   【2026-10-04 追加】
   ・マウスを乗せても止まらない：テーマはマウスが乗る／フォーカスが入ると pause() を
     呼んで自動再生を止める。この部品の対象スライダーだけ pause() を何もしない関数に
     差し替える（ストップボタンも出さないので、止める操作自体を無くしている）。
     矢印・ドットで手動で切り替えたときは、直後に次へ進まないよう間隔を数え直す。
   ・矢印とドット（ガイド）を画像の下端に重ねる：見た目は sections/slideshow.liquid の
     style。重ねる位置（画像の下端）はスマホで文字が画像の下に出るためJSで計算する。

   【2026-10-05 追加】切り替えの瞬間に止まって見える対策
   ・読み込み完了後に全スライドの画像を先に読み込み・表示準備しておく（warmUpImages）
   ・消えていく複製は表示中と同じ画像ファイルを使う（サイズの選び直しをさせない）
   ========================================================================== */
(function () {
  'use strict';

  var FADE_MS = 900;      // フェードの長さ（ミリ秒）
  var ZOOM_SCALE = 1.08;  // 拡大の倍率（1.08 ＝ 8% 大きくなる）

  /* 拡大の見た目（1回だけ追加）。拡大は .lumiere-zoom が付いた画像だけ。
     外すと transition なしで元の大きさへ一瞬で戻る（見えていないスライドで行う） */
  function addZoomStyle() {
    if (document.getElementById('lumiere-slideshow-zoom-style')) return;
    var style = document.createElement('style');
    style.id = 'lumiere-slideshow-zoom-style';
    style.textContent =
      '.slideshow .slideshow__media{overflow:hidden}' +
      '.slideshow .slideshow__media img{transform:scale(1);transition:none;will-change:transform}' +
      '.slideshow .slideshow__media img.lumiere-zoom{transform:scale(' + ZOOM_SCALE + ');' +
      'transition:transform var(--lumiere-zoom-ms,8000ms) linear}';
    document.head.appendChild(style);
  }

  function setup(component) {
    var slider = component.querySelector('.slideshow.slider');
    if (!slider || slider.dataset.lumiereFade) return;
    slider.dataset.lumiereFade = '1';

    /* スクロールは瞬時に（滑る動きとフェードが重なると見づらいため）。
       指でのスワイプは scroll-behavior の影響を受けない */
    slider.style.scrollBehavior = 'auto';

    var overlay = null;
    var originalScrollTo = slider.scrollTo.bind(slider);

    function currentSlide() {
      var slides = slider.querySelectorAll('.slideshow__slide');
      if (!slides.length) return null;
      var width = slides[0].clientWidth || 1;
      var index = Math.round(slider.scrollLeft / width);
      return slides[Math.max(0, Math.min(slides.length - 1, index))];
    }

    /* ---------- ゆっくり拡大 ---------- */
    var speed = parseFloat(slider.dataset.speed) || 0;
    var autoplay = slider.dataset.autoplay === 'true';
    /* 次へ切り替わってフェードし終わるまで、ずっと少しずつ大きくなる長さ */
    var zoomMs = autoplay && speed ? speed * 1000 + FADE_MS * 2 : 8000;
    component.style.setProperty('--lumiere-zoom-ms', zoomMs + 'ms');

    function zoomImage(slide) {
      return slide && slide.querySelector('.slideshow__media img');
    }

    /* 表示中のスライドの画像だけ拡大を始め、ほかは元の大きさに戻す */
    function startZoom(slide) {
      slider.querySelectorAll('.slideshow__media img.lumiere-zoom').forEach(function (img) {
        if (img !== zoomImage(slide)) img.classList.remove('lumiere-zoom');
      });
      var img = zoomImage(slide);
      if (!img || img.classList.contains('lumiere-zoom')) return;
      /* 元の大きさを一度描画してから付ける（同じフレームだと拡大が始まらない） */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          img.classList.add('lumiere-zoom');
        });
      });
    }

    /* ---------- 画像を前もって準備しておく ----------
       2枚目以降は「後で読み込む」（loading=lazy）設定のため、初めて表示する切り替えの
       瞬間に読み込み・表示準備（デコード）が入り、画面が止まって見えた
       （2026-10-05 確認：特に1周目の最後→最初）。ページの読み込みが終わったら、
       全スライドの画像を1枚ずつ先に読み込んで、表示準備まで済ませておく。 */
    function warmUpImages() {
      var imgs = Array.prototype.slice.call(slider.querySelectorAll('.slideshow__media img'));
      (function next() {
        var img = imgs.shift();
        if (!img) return;
        img.loading = 'eager';
        var ready = img.complete ? Promise.resolve() : new Promise(function (resolve) {
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', resolve, { once: true });
        });
        ready
          .then(function () { return img.decode ? img.decode() : null; })
          .catch(function () {})
          .then(next);
      })();
    }
    if (document.readyState === 'complete') warmUpImages();
    else window.addEventListener('load', warmUpImages, { once: true });

    /* スマホのスワイプなど、スクロール命令を通らない切り替えにも追従する */
    component.addEventListener('slideChanged', function () {
      startZoom(currentSlide());
      placeControls();
    });
    startZoom(currentSlide());

    /* ---------- マウスを乗せても止めない ---------- */
    if (typeof component.play === 'function' && autoplay) {
      component.pause = function () {};
      component.play(); // 読み込み中にマウスが乗って止まっていた場合も動かす
      /* 手動で切り替えた直後に自動で次へ進まないよう、間隔を数え直す */
      component.addEventListener('click', function (event) {
        if (event.target.closest('.slider-button, .slider-counter__link')) component.play();
      });
    }

    /* ---------- 矢印とドットを画像の下端に重ねる ---------- */
    function placeControls() {
      var controls = component.querySelector('.slideshow__controls');
      var slide = currentSlide();
      var media = slide && slide.querySelector('.slideshow__media');
      if (!controls || !media) return;
      var top = media.getBoundingClientRect().bottom - component.getBoundingClientRect().top - controls.offsetHeight;
      controls.style.top = Math.max(0, Math.round(top)) + 'px';
      controls.style.bottom = 'auto';
    }
    placeControls();
    window.addEventListener('resize', placeControls, { passive: true });
    window.addEventListener('load', placeControls);

    function removeOverlay() {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
      overlay = null;
    }

    slider.scrollTo = function (options) {
      var left = options && typeof options === 'object' ? options.left : arguments[0];
      /* 位置が変わらないときはそのまま */
      if (typeof left !== 'number' || Math.abs(left - slider.scrollLeft) < 2) {
        return originalScrollTo.apply(null, arguments);
      }

      var slide = currentSlide();
      removeOverlay();

      if (slide) {
        /* いま見えているスライドの複製を、スライダーと同じ位置・大きさで重ねる */
        overlay = document.createElement('div');
        /* スライダーと同じ class を引き継ぐ。スマホで「文字を画像の下に出す」
           （banner--mobile-bottom）などの配置がスライダー基準のCSSで決まっているため、
           引き継がないと複製だけ文字が画像の上に出てしまう（2026-10-04 確認）。
           出現アニメーション用の class は外す */
        overlay.className = slider.className
          .split(/\s+/)
          .filter(function (c) { return c && c !== 'scroll-trigger' && c.indexOf('animate--') !== 0; })
          .concat('lumiere-slideshow-fade')
          .join(' ');
        overlay.setAttribute('aria-hidden', 'true');
        var copy = slide.cloneNode(true);
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
        copy.querySelectorAll('a, button').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
        /* 拡大の途中の大きさから始めて、薄れている間も同じ速さで拡大を続ける。
           ★ 以前はその大きさで止めて薄れさせていたため、切り替えの0.9秒間だけ
             拡大が止まって見えた（2026-10-04 修正）。
           （class のままだと最終の大きさへ飛ぶので、大きさは数値で指定する） */
        var liveImg = zoomImage(slide);
        var copyImg = zoomImage(copy);
        var copyZoomTo = null;
        if (liveImg && copyImg) {
          var matrix = window.getComputedStyle(liveImg).transform;
          var nowScale = 1;
          var m = matrix && matrix.match(/^matrix\(([^,]+)/);
          if (m) nowScale = parseFloat(m[1]) || 1;
          var perMs = (ZOOM_SCALE - 1) / zoomMs; // 表示中と同じ拡大の速さ
          copyZoomTo = nowScale + perMs * FADE_MS;
          copyImg.classList.remove('lumiere-zoom');
          copyImg.style.setProperty('transition', 'none', 'important');
          copyImg.style.setProperty('transform', 'scale(' + nowScale + ')', 'important');
          /* 表示中と同じ画像ファイルをそのまま使う（複製でブラウザがサイズを選び直すと、
             大きな画像の読み込み・表示準備がやり直しになり、切り替えの瞬間に画面が止まる） */
          if (liveImg.currentSrc) {
            copyImg.removeAttribute('srcset');
            copyImg.removeAttribute('sizes');
            copyImg.removeAttribute('loading');
            copy.querySelectorAll('picture source').forEach(function (el) { el.remove(); });
            copyImg.src = liveImg.currentSrc;
          }
        }
        overlay.appendChild(copy);
        overlay.style.cssText =
          'position:absolute;pointer-events:none;overflow:hidden;z-index:1;' +
          'top:' + slider.offsetTop + 'px;left:' + slider.offsetLeft + 'px;' +
          'width:' + slider.clientWidth + 'px;height:' + slider.clientHeight + 'px;' +
          'opacity:1;transition:opacity ' + FADE_MS + 'ms ease;';
        /* 複製はスライダーの外に置くため、テーマの列幅指定（.grid__item の 50% など）が
           効いてしまう。必ずスライダーいっぱいに広げる */
        ['width', 'max-width', 'min-width', 'height'].forEach(function (prop) {
          copy.style.setProperty(prop, '100%', 'important');
        });
        copy.style.setProperty('margin', '0', 'important');
        copy.style.setProperty('flex', 'none', 'important');
        slider.parentNode.insertBefore(overlay, slider.nextSibling);
      }

      /* 下で瞬時に次のスライドへ切り替え、次の画像の拡大を元の大きさから始める */
      var result = originalScrollTo({ left: left, behavior: 'instant' });
      startZoom(currentSlide());
      placeControls();

      if (overlay) {
        var fading = overlay;
        /* 重ねた状態を一度描画してから透明にする（同じフレームだとフェードしない） */
        var fadingImg = copyZoomTo ? zoomImage(fading) : null;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            fading.style.opacity = '0';
            if (fadingImg) {
              fadingImg.style.setProperty('transition', 'transform ' + FADE_MS + 'ms linear', 'important');
              fadingImg.style.setProperty('transform', 'scale(' + copyZoomTo + ')', 'important');
            }
          });
        });
        setTimeout(function () {
          if (fading === overlay) removeOverlay();
          else if (fading.parentNode) fading.parentNode.removeChild(fading);
        }, FADE_MS + 100);
      }
      return result;
    };
  }

  function init() {
    if (!window.customElements) return;
    addZoomStyle();
    customElements.whenDefined('slideshow-component').then(function () {
      document.querySelectorAll('slideshow-component').forEach(setup);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
